<template>
  <div class='page-wrapper'>
     <slot></slot>
  </div>
</template>

<script>
export default {
   name: "page-wrapper",
   props: {
      top: {
         type: Boolean,
         default: false,
      }
   }
}
</script>

<style lang='scss' scoped>
.page-wrapper
{
   width: 100%;
   min-height: 100vh;
   display: flex;
   align-items: center;
   justify-content: center;
   flex-direction: column;
   
}
</style>